Object.defineProperty(exports, '__esModule', { value: true });

var tslib = require('tslib');
var React = require('react');
var mergeRefs = require('react-merge-refs');
var cn = require('classnames');
var coreComponentsDrawer = require('../../drawer');
var components_content_Component_desktop = require('../components/content/Component.desktop.js');
var components_controls_Component = require('../components/controls/Component.js');
var components_footer_Component_desktop = require('../components/footer/Component.desktop.js');
var components_header_Component = require('../components/header/Component.js');
var consts = require('../consts.js');
var ResponsiveContext = require('../ResponsiveContext.js');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

var React__default = /*#__PURE__*/_interopDefaultCompat(React);
var mergeRefs__default = /*#__PURE__*/_interopDefaultCompat(mergeRefs);
var cn__default = /*#__PURE__*/_interopDefaultCompat(cn);

var styles = {"size-500":"side-panel__size-500_1899d","hidden":"side-panel__hidden_1899d"};
require('./desktop.css');

var transitions = {"enterRight":"side-panel__enterRight_1i44e","enterLeft":"side-panel__enterLeft_1i44e","enterActive":"side-panel__enterActive_1i44e","exit":"side-panel__exit_1i44e","exitActiveRight":"side-panel__exitActiveRight_1i44e","exitActiveLeft":"side-panel__exitActiveLeft_1i44e"};
require('./transitions.desktop.css');

var SidePanelDesktopComponent = React.forwardRef(function (_a, ref) {
    var _b, _c;
    var _d = _a.size, size = _d === void 0 ? 500 : _d, children = _a.children, className = _a.className, wrapperClassName = _a.wrapperClassName, _e = _a.contentTransitionProps, contentTransitionProps = _e === void 0 ? {} : _e, backdropProps = _a.backdropProps, _f = _a.placement, placement = _f === void 0 ? 'right' : _f, dataTestId = _a.dataTestId, restProps = tslib.__rest(_a, ["size", "children", "className", "wrapperClassName", "contentTransitionProps", "backdropProps", "placement", "dataTestId"]);
    var responsiveContext = React.useContext(ResponsiveContext.ResponsiveContext);
    var modalRef = React.useRef(null);
    var enterCn = cn__default.default((_b = {},
        _b[transitions.appearRight] = placement === 'right',
        _b[transitions.appearLeft] = placement === 'left',
        _b));
    var exitCn = cn__default.default((_c = {},
        _c[transitions.exitActiveRight] = placement === 'right',
        _c[transitions.exitActiveLeft] = placement === 'left',
        _c));
    var contextValue = React__default.default.useMemo(function () { return ({ size: size, view: 'desktop', dataTestId: dataTestId }); }, [size, dataTestId]);
    var renderContent = function () { return (React__default.default.createElement(coreComponentsDrawer.Drawer, tslib.__assign({}, restProps, { dataTestId: dataTestId, ref: mergeRefs__default.default([ref, modalRef]), placement: placement, wrapperClassName: wrapperClassName, className: cn__default.default(className, styles[consts.SIZE_TO_CLASSNAME_MAP[size]], styles.hidden), backdropProps: backdropProps, contentTransitionProps: tslib.__assign({ classNames: {
                appear: enterCn,
                enter: enterCn,
                appearActive: transitions.enterActive,
                enterActive: transitions.enterActive,
                exit: transitions.exit,
                exitActive: exitCn,
                exitDone: exitCn,
            } }, contentTransitionProps) }), React__default.default.Children.map(children, function (child) {
        return React.isValidElement(child) ? React.cloneElement(child, { size: size }) : child;
    }))); };
    var renderWithContext = function () { return (React__default.default.createElement(ResponsiveContext.ResponsiveContext.Provider, { value: contextValue }, renderContent())); };
    return responsiveContext ? renderContent() : renderWithContext();
});
var SidePanelDesktop = Object.assign(SidePanelDesktopComponent, {
    Content: components_content_Component_desktop.ContentDesktop,
    Header: components_header_Component.Header,
    Footer: components_footer_Component_desktop.FooterDesktop,
    Controls: components_controls_Component.Controls,
});

exports.SidePanelDesktop = SidePanelDesktop;
